module.exports = __webpack_public_path__ + "static/media/select-arrow.87b5ddb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/select-arrow.svg
// module id = 96
// module chunks = 3